import { createContext, useState } from "react";

export const CancelContext = createContext({
    userInfo: {},
    cancelInfo: {},
    loading: true,
    changeUserInfo: () => {},
    changeCancelInfo: () => {},
    getTitle: () => {},
    getDesc: () => {},
    getPauseOption: ()=>{},
    setLoading: () => {}
});

export const CancelProvider = ({children}) => {
    const [userInfo, setUserInfo] = useState({});
    const [cancelInfo, setCancelInfo] = useState({});
    const [loading, setLoading] = useState(true);
    const changeUserInfo = (newUserInfo) =>{
        setUserInfo({...userInfo,...newUserInfo});
    }
    const changeCancelInfo= (newCancelInfo) => {
        setCancelInfo({...cancelInfo,...newCancelInfo});
    }

    const getTitle = (page) =>{
        if(page==="offer"){
            if(cancelInfo.category === "fin_cat"){
                return "How does a lower price sound?"
            }else if(cancelInfo.category === "prod_cat"){
                return "Product issues?"
            } else {
                return "Canceling for personal reasons?"
            }
        } else if (page ==="keep"){
            if (cancelInfo.choice==="reduced"){
                return `Reduced price confirmed &#x1F911;`
            } else {
                return `Sticking with us? Fantastic news! &#x1F31F;`
            }
        }
    }

    const getDesc = (page) =>{
        if(page==="offer"){
            if(cancelInfo.category === "fin_cat"){
                return "Let us ease your burden and reduce the price of your subscription."
            }else if(cancelInfo.category === "prod_cat"){
                return "We’re so sorry to hear that the products aren’t meeting your needs. If it’s an issue of cost, we’d love to offer you a reduced price per box!"
            } else {
                return "Let us ease the burden! We’re offering loyal subscribers like you a reduced price."
            }
        } else if (page ==="keep"){
            if (cancelInfo.choice==="reduced"){
                return `We’re thrilled to keep you in the Tum To Mom community. Your boxes will be $27 each + shipping going forward. Keep an eye on your inbox for an email that confirms this new price.<br/><br/>If you need any wedding-related gifts for you or your bridal party before your next box arrives, check out our Shop.`
            } else {
                return `We're overjoyed you're continuing your journey with Tum to Mom Subscription Box. Every moment of motherhood is precious, and we're excited to be a part of your adventure, offering support and surprises along the way.`
            }
        }
    }

    const getPauseOption = () =>{
        if(userInfo && userInfo.plan_code){
            if(userInfo.plan_code.search("2week-plan") > 0){//not on ttm yet
               return [{text:"2 weeks", value:"1"}, {text:"4 weeks", value:"2"}, {text:"6 weeks", value:"3"}];
            } else if(userInfo.plan_code.search("-e1m") > 0){
                return [{text:"1 month", value:"1"}, {text:"2 months", value:"2"}, {text:"3 months", value:"3"}];
            } else if(userInfo.plan_code.search("-e2m") > 0){
                return [{text:"2 month", value:"1"}, {text:"4 months", value:"2"}, {text:"6 months", value:"3"}];
            } else if(userInfo.plan_code.search("-e3m") > 0){
                return [{text:"3 month", value:"1"}, {text:"6 months", value:"2"}, {text:"9 months", value:"3"}];
            } 
          }
    }

    const value = {
        userInfo, 
        cancelInfo,
        loading,
        changeUserInfo,
        changeCancelInfo,
        getTitle,
        getDesc,
        getPauseOption,
        setLoading
};

    return <CancelContext.Provider value={value}>
                <div className="loading-placeholder" style={{display:(loading?"block":"none")}}>
                    <div>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                    </div>
                </div>        
                {children}
            </CancelContext.Provider>
}